export enum FooterMenuGroupNameEnum {
  Products = 'products',
  MainGroup = 'mainGroup',
  ForInstallers = 'forInstallers',
}
